import { ContainerDirective, LeafDirective, TextDirective } from 'mdast-util-directive'
import type { Element } from 'hast'
import { toHast } from 'mdast-util-to-hast'

function processNotice(
  node: TextDirective | LeafDirective | ContainerDirective
) {
  const allowedTypes = ['warning', 'important', 'note', 'tip', 'info']
  // @ts-ignore
  const firstElementKey = Object.keys(node.attributes)[0]
  let currentType: string | undefined = ''

  // @ts-ignore
  if (Object.hasOwn(node.attributes, 'title')) {
    // @ts-ignore
    currentType = String(node.attributes.title).toLowerCase()
  } else if (allowedTypes.indexOf(firstElementKey) !== -1) {
    currentType = firstElementKey.toLowerCase()
  } else {
    console.error('notice directive: invalid type', node)
    return
  }

  if (!allowedTypes.includes(currentType)) {
    console.error('Notice directive: invalid type', node)
    return
  }

  node.data = node.data ?? {}
  node.data.hName = 'section'
  node.data.hProperties = {
    className: 'sc-notice ' + currentType,
  }

  const icon: Element = {
    type: 'element',
    tagName: 'svg',
    properties: {
      className: 'notice-icon',
      variant: currentType,
    },
    children: [],
  }

  const content: Element = {
    type: 'element',
    tagName: 'p',
    properties: {
      className: node.name + '-icon',
    },
    children: [
      {
        type: 'text',
        value: currentType,
      },
    ],
  }

  node.data.hChildren = [
    {
      type: 'element',
      tagName: 'div',
      properties: {
        className: 'notice-title',
      },
      children: [icon, content],
    },
    {
      type: 'element',
      tagName: 'div',
      properties: {
        className: 'notice-content',
      },
      // @ts-expect-error not all content types can be translated as inner content of element
      children: node.children.map(toHast),
    },
  ]
}

export default processNotice